import React from "react";
import MeteredItemsPage from "../components/MeteredItemsPage";

function MinderDanNul() {
    return (
        <MeteredItemsPage
            itemFilter={(item, voorraad) =>
                Boolean(
                    voorraad.stock &&
                        voorraad.stock[item.order_number] !== undefined &&
                        voorraad.stock[item.order_number] < 0
                )
            }
        />
    );
}

export default MinderDanNul;
